import BusinessTravellerSelectHotelsRoomsContent from './BusinessTravellerSelectHotelsRoomsContent'
import * as React from 'react'
import { SearchMenuStates } from 'components/Search/type'
import { RefObject } from 'react'

import DropdownList from 'LuxKit/Dropdown/List/DropdownList'

interface Props {
  activeMenu: SearchMenuStates
  onClose: () => void
  onApply: () => void
  roomInputRef: RefObject<HTMLButtonElement | null>
}

export default function BusinessTravellerSelectHotelsRoomsDesktop({
  activeMenu,
  onClose,
  onApply,
  roomInputRef,
}: Props) {
  return <DropdownList
    size="S"
    autoHeight
    anchorRef={roomInputRef}
    triggerRef={roomInputRef}
    open={activeMenu === SearchMenuStates.BusinessTravellerMultiRoomsHotelSelect}
    onClose={onClose}
    primaryActionProps={{
      children: 'Apply',
      onClick: onApply,
    }}
    placement="bottom-start"
    portaled
  >
    <BusinessTravellerSelectHotelsRoomsContent />
  </DropdownList>
}
